/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import {
  deployEnv,
  isDeployDevelopment,
  isDeployProduction,
  cloudConsoleUrl
} from './config';

export const getInitials = name => {
  if (!name) {
    return '';
  }
  let initials = name.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  return initials;
};

type FooterUrls = Partial<{
  cloudDashboard: string;
  addUsers: string;
  manageUsers: string;
  usageBilling: string;
}>;

export const getFooterUrls = (region: string) => {
  const footerUrls: FooterUrls = {};
  if (cloudConsoleUrl) {
    footerUrls.cloudDashboard = cloudConsoleUrl;
  }

  let env_id: string;
  if (isDeployProduction(deployEnv)) {
    env_id = 'env_id=ibm%3Ayp%3A' + region;
  } else if (isDeployDevelopment(deployEnv)) {
    env_id = 'env_id=ibm%3Ays1%3A' + region;
  }

  if (env_id) {
    footerUrls.addUsers = `${footerUrls.cloudDashboard}/iam/?${env_id}#/add-users`;
  }

  if (env_id) {
    footerUrls.manageUsers = `${footerUrls.cloudDashboard}/iam/?${env_id}#/users`;
  }

  footerUrls.usageBilling = footerUrls.cloudDashboard
    ? `${footerUrls.cloudDashboard}/billing/usage`
    : null;
  return footerUrls;
};
